import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { calculateScrollDistance, getTotalScrollDistance } from '../utils';
import { useDeviceType } from '../../../../responsive';
/** Хук реализует всю логику над кнопками скролящегося контейнера табов */
export var useCarouselButtons = function useCarouselButtons(_ref) {
  var scrollableContainerRef = _ref.scrollableContainerRef,
    tabsRef = _ref.tabsRef;
  var deviceType = useDeviceType();
  var _useState = useState({
      showLeftCarouselButton: false,
      showRightCarouselButton: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    buttonsVisibilityState = _useState2[0],
    setButtonsVisibilityState = _useState2[1];
  useEffect(function () {
    var scrollableContainer = scrollableContainerRef.current;
    if (!scrollableContainer) {
      return function () {};
    }
    var calculateButtonsVisibility = function calculateButtonsVisibility() {
      setButtonsVisibilityState({
        showLeftCarouselButton: scrollableContainer.scrollLeft > 0,
        showRightCarouselButton: scrollableContainer.scrollWidth > Math.round(scrollableContainer.clientWidth + scrollableContainer.scrollLeft)
      });
    };
    calculateButtonsVisibility();

    // При ресайзе пересчитываем возможность отображение кнопок
    window.addEventListener('resize', calculateButtonsVisibility);

    // При скролле вычисляем, какие кнопки показывать
    scrollableContainer.addEventListener('scroll', calculateButtonsVisibility);
    return function () {
      window.removeEventListener('resize', calculateButtonsVisibility);
      scrollableContainer.removeEventListener('scroll', calculateButtonsVisibility);
    };
  }, [scrollableContainerRef, deviceType]);
  var handleLeftChevronClick = useCallback(function () {
    var scrollableContainer = scrollableContainerRef.current;
    var tabsContainer = tabsRef.current;
    var tabs = Array.from(tabsContainer.children).slice().reverse();
    var scrollDistance = calculateScrollDistance({
      items: tabs,
      container: scrollableContainer,
      direction: 'left'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'left'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, tabsRef]);
  var handleRightChevronClick = useCallback(function () {
    var scrollableContainer = scrollableContainerRef.current;
    var tabsContainer = tabsRef.current;
    var tabs = Array.from(tabsContainer.children);
    var scrollDistance = calculateScrollDistance({
      items: tabs,
      container: scrollableContainer,
      direction: 'right'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'right'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, tabsRef]);
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, buttonsVisibilityState), {}, {
      onLeftCarouselButtonClick: handleLeftChevronClick,
      onRightCarouselButtonClick: handleRightChevronClick
    });
  }, [buttonsVisibilityState, handleLeftChevronClick, handleRightChevronClick]);
};